/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, WebAppGetYoutubeIntegrationStatsCountryViewersPathParams, WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams, WebAppGetYoutubeIntegrationStatsCountryViewers401, WebAppGetYoutubeIntegrationStatsCountryViewers403 } from "../models/WebAppGetYoutubeIntegrationStatsCountryViewers";

export function getWebAppGetYoutubeIntegrationStatsCountryViewersUrl(station: WebAppGetYoutubeIntegrationStatsCountryViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/web-app/v1/youtube-stats/viewers/${station}/country` as const }
  return res
}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel. `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /web-app/v1/youtube-stats/viewers/:station/country}
 */
export async function webAppGetYoutubeIntegrationStatsCountryViewers(station: WebAppGetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsCountryViewers401 | WebAppGetYoutubeIntegrationStatsCountryViewers403>, unknown>({ method : "GET", url : getWebAppGetYoutubeIntegrationStatsCountryViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}